// extracted by mini-css-extract-plugin
var _1 = "768px";
var _2 = "Subquestion_multipleContainer__v9dxd";
var _3 = "Subquestion_questionLabel__5g5rl";
var _4 = "Subquestion_radioButton__7lEGa";
var _5 = "'../../../shared.module.css'";
export { _1 as "md", _2 as "multipleContainer", _3 as "questionLabel", _4 as "radioButton", _5 as "shared" }
